import actionTypes from "../../redux/actionTypes";
import { ActionCreator, Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../../redux/initialState";
import { SelectedLocation } from "./selectLocationTypes";

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, SelectedLocation, Action<string>>>;

export const updateLocationFilter: ActionCreator<ThunkAction<void, ApplicationState, any, Action<string>>> = selectedLocation => {
  return (dispatch: Dispatch): Action => {
    try {
      return dispatch({
        type: actionTypes.UPDATE_LOCATION_FILTER_SUCCESS,
        payload: selectedLocation,
      });
    } catch (e) {
      return dispatch({
        type: actionTypes.UPDATE_LOCATION_FILTER_ERROR,
        payload: null,
      });
    }
  };
};
